import { z } from 'zod';
export const permissionStatusSchema = z.strictObject({
    /** Nome da permissão de aplicativo no Microsoft Graph. */
    name: z.string(),
    purpose: z.string(),
    granted: z.boolean(),
});
export const permissionsReportSchema = z.strictObject({
    /** `true` quando o bot consegue enviar para qualquer pessoa da organização. */
    ready: z.boolean(),
    permissions: z.array(permissionStatusSchema),
    /**
     * Se o app está publicado no catálogo da organização. `null` quando não dá
     * para saber, porque falta a permissão de leitura do catálogo.
     */
    appInOrgCatalog: z.boolean().nullable(),
    /**
     * `TEAMS_APP_ID` deste ambiente: o `id` do manifest, que o catálogo mostra
     * como App ID. É por ele que o backend procura o app.
     */
    teamsAppId: z.string(),
});
//# sourceMappingURL=permissions.contract.js.map